/* eslint-disable react/display-name */
import React from 'react';

import * as css from './drawer-statistics.css';
import * as sys from '../../system';

const stats = [
  {
    heading: 'Superior ROI',
    numbers: '181%',
    content:
      '<strong style="font-weight: 700">ROI</strong>. Less than a year before you see returns on your investment, according to an <a href="https://info.rasa.com/forrester-tei-report-2021" target="_blank" rel="noopener">independent study</a>.',
  },
  {
    heading: 'High Impact',
    numbers: '60%',
    content:
      '<strong style="font-weight: 700">Containment Rates</strong>. Attentive interactions across all touchpoints - allowing employees to focus on higher value tasks while automating the rest.',
  },
  {
    heading: 'Transformational',
    numbers: '25M',
    content:
      '<strong style="font-weight: 700">Downloads</strong>. Infrastructure foundation used by hundreds of organizations, and core developer workflows used by millions',
  },
];

export default function Statistics({ customData }) {
  return (
    <section css={[css.section]} className="reset2">
      <div css={[sys.wrapLast, css.frame, css.grid]}>
        {stats.map((stat) => (
          <div key={stat.heading} css={css.cell}>
            <h3 css={css.heading}>{stat.heading}</h3>
            <p css={css.numbers}>{stat.numbers}</p>
            <p css={css.content} dangerouslySetInnerHTML={{ __html: stat.content }} />
          </div>
        ))}
      </div>
    </section>
  );
}
